module.exports = __webpack_public_path__ + "img/addhover.2a227e56.svg";